import { array, object, string } from "../../../types/_types";

import { PipelineStep } from "./PipelineStep";

export const Pipeline = object({
	id: string(),
	name: string(3),
	steps: array(PipelineStep),
});
